import { aquaAxios } from './utilityFunctions';
import Env from './Env';
import { verifyLocalizedAssetOnRemote } from './StaticAssetsManifest';
import { LOCALIZATIONS } from './constants';

export const RESOURCE_TYPES = {
  AUDIO: 'audio',
  IMAGE: 'image',
};

const getFullPath = ({ file, path, countryCode }) => {
  const apiUrl = Env.GAME_CONTENT_URL;
  let fullPath = `${apiUrl}/${path}${countryCode}/${file}`;
  if (countryCode !== 'en') {
    // check if localized asset is available.
    let exists = verifyLocalizedAssetOnRemote(`${path}${countryCode}/${file}`);
    if (!exists && countryCode === LOCALIZATIONS.SPA_ES_DEFAULT) {
      fullPath = `${apiUrl}/${path}${LOCALIZATIONS.ES}/${file}`;
      exists = verifyLocalizedAssetOnRemote(`${path}${LOCALIZATIONS.ES}/${file}`);
    }
    if (!exists) {
      // if localized asset is not available defaut to english asset
      fullPath = `${apiUrl}/${path}en/${file}`;
    }
  }
  return fullPath;
};

const fetchBase64String = async (assetObj, header) => {
  // Establish path to S3 bucket
  const fullPath = getFullPath(assetObj);
  // Grab audio from S3 bucket
  try {
    const { data } = await aquaAxios(fullPath, { responseType: 'arraybuffer', timeout: 0 });
    const buffer = data;
    // String.fromCharCode overloads if it is more then 64 kb
    const byteLimit = 63000;
    const batches = buffer.byteLength / byteLimit;
    let base64String = '';
    let length = 0;
    // Convert to base64
    for (let i = 0; i < batches; i++) {
      length = byteLimit;
      if (i + 1 > batches) { // Last run
        length = buffer.byteLength - (i * byteLimit);
      }
      base64String += btoa(String.fromCharCode(...new Uint8Array(buffer, i * byteLimit, length)));
    }
    // return base64 string
    return `${header};base64,${base64String}`;
  } catch (error) {
    error.fileName = fullPath;
    throw error;
  }
};

/**
 * Fetches only the audio file
 * for a given address.
 *
 * @param {string} fileName
 */
export const fetchAudio = assetObj => fetchBase64String(assetObj, 'data:audio/mpeg');

/**
 * Fetches only the json file
 * for a given address.
 *
 * @param {string} fileName
 */
export async function fetchJson(assetObj) {
  // Establish path to S3 bucket
  const fullPath = getFullPath(assetObj);
  try {
    const { data } = await aquaAxios(fullPath, { timeout: 0 });
    return data;
  } catch (error) {
    error.fileName = fullPath;
    throw error;
  }
}

export async function fetchAnimation(assetObj) {
  const framesFileName = `${assetObj.file.split('.json')[0]}.frames.json`;

  return Promise.all([
    fetchJson(assetObj),
    fetchJson({ ...assetObj, file: framesFileName }),
  ]);
}

export const fetchSvg = assetObj => fetchBase64String(assetObj, 'data:image/svg+xml');

export default fetchAudio;
